// Oglinda pe client a App\Utils\Budget\BudgetCalculator (conso-api) — pentru preview LIVE
// in timp ce userul editeaza. Backend-ul ramane sursa de adevar la salvare.

export const INCOME_TYPES = [
    { value: 'salary', label: 'Salariu', coef: 1.0 },
    { value: 'rent', label: 'Chirii', coef: 0.75 },
    { value: 'dividends', label: 'Dividende', coef: 0.5 },
    { value: 'other', label: 'Alte venituri', coef: 0.5 },
];

export const EXPENSE_TYPES = [
    { value: 'housing', label: 'Locuință' },
    { value: 'utilities', label: 'Utilități' },
    { value: 'food', label: 'Alimente' },
    { value: 'transport', label: 'Transport' },
    { value: 'loans', label: 'Rate credite' },
    { value: 'insurance', label: 'Asigurări' },
    { value: 'other', label: 'Altele' },
];

export const LOAN_EXPENSE_TYPES = ['loans'];

const DTI_RATE = { RON: 0.4, EUR: 0.2, USD: 0.2 };

const incomeCoef = (type) => {
    const found = INCOME_TYPES.find((t) => t.value === type);
    return found ? found.coef : 0.5;
};

export const incomeTypeLabel = (type) => {
    const found = INCOME_TYPES.find((t) => t.value === type);
    return found ? found.label : type;
};

export const expenseTypeLabel = (type) => {
    const found = EXPENSE_TYPES.find((t) => t.value === type);
    return found ? found.label : type;
};

export const computeSummary = (incomeSources = [], expenseCategories = [], currency = 'RON') => {
    const dtiRate = DTI_RATE[currency] !== undefined ? DTI_RATE[currency] : 0.4;

    let totalIncome = 0;
    let eligibleIncome = 0;
    incomeSources.forEach((i) => {
        const amount = parseInt(i.amount, 10) || 0;
        totalIncome += amount;
        eligibleIncome += amount * incomeCoef(i.type);
    });
    eligibleIncome = Math.round(eligibleIncome);

    let totalExpenses = 0;
    let existingLoans = 0;
    expenseCategories.forEach((e) => {
        const amount = parseInt(e.amount, 10) || 0;
        totalExpenses += amount;
        if (LOAN_EXPENSE_TYPES.includes(e.type)) {
            existingLoans += amount;
        }
    });

    const availableBalance = totalIncome - totalExpenses;
    const debtToIncome = eligibleIncome > 0
        ? Math.round((existingLoans / eligibleIncome) * 1000) / 10
        : 0;
    let borrowingCapacity = Math.round(eligibleIncome * dtiRate) - existingLoans;
    if (borrowingCapacity < 0) borrowingCapacity = 0;

    return {
        currency,
        dtiRate,
        totalIncome,
        eligibleIncome,
        totalExpenses,
        existingLoans,
        availableBalance,
        debtToIncome,
        borrowingCapacity,
        dtiOverLimit: debtToIncome > dtiRate * 100,
    };
};

export const formatRON = (value, currency = 'RON') =>
    `${new Intl.NumberFormat('ro-RO').format(Math.round(value || 0))} ${currency}`;
